import { Button } from '@single-platform/button';
import styled from 'styled-components';

export const MainWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 33.75rem;
  min-width: 33.75rem;
  height: 80vh;
  justify-content: space-between;

  @media screen and (max-width: 430px) {
    width: 100%;
    min-width: 100%;
    padding: 0 1rem;
  }
`;

export const Wrapper = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
`;

export const TitleStyles = styled.div`
  text-align: left;
  font-size: 1.5rem;
  font-weight: 37.5rem;
  line-height: 2rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
`;

export const GapContainer = styled.div`
  gap: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BottomContainer = styled.div`
  margin-bottom: 0 auto;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 1rem;
`;
